export default __webpack_public_path__ + "static/media/loggedin-employees.da555672.svg";